export function normalizePlate(plate) {
    if (plate === null || plate === "" || plate == undefined) {
        return "";
    }
    return plate.toUpperCase().replace(/\s/g, "");
}